import { render, staticRenderFns } from "./UILeagueTopAvatars.vue?vue&type=template&id=99583062"
import script from "./UILeagueTopAvatars.vue?vue&type=script&lang=js"
export * from "./UILeagueTopAvatars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default})
